import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "./assets/css/index.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { UsersProvider } from "context/usersContext";
import { SocketProvider } from "context/socketContext";
import SSRProvider from 'react-bootstrap/SSRProvider';
import { AuthProvider } from 'react-auth-kit';


ReactDOM.render(
	<React.StrictMode>

		<AuthProvider 
			authType={'cookie'}
			authName={'_auth'}
			cookieDomain={window.location.hostname}
			cookieSecure={window.location.protocol === 'https'}
		>
			<SocketProvider> 
				<UsersProvider>
					<SSRProvider>
					<App />
					</SSRProvider>
				</UsersProvider>
				</SocketProvider>
		</AuthProvider>

	</React.StrictMode>,
	document.getElementById("root")
);
